module.exports = __webpack_public_path__ + "static/img/qrcode-empty.1770538668457.png";